<template>
  <v-app  >
        <v-row >
          <v-col class="no-padding" ><Navigation /></v-col>
        </v-row>
        <v-row>
           <v-col ><router-view/></v-col>
        </v-row>
        <v-row>
           <v-col cols="12" center><FooterMenuBasic/></v-col>
        </v-row>
  </v-app>
</template>

<script>
import Navigation from '@/components/header/Navigation';
import FooterMenuBasic from "@/components/footer/FooterMenuBasic";
export default {
  name: "App",
  components:{
    Navigation,
    FooterMenuBasic
  }
};
</script>
<style scoped>
.no-padding{
    width: 100%;
     padding: 0px !important; 
}
</style>
